var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "pdf-ref",
      staticClass: "pdf-render-wrap",
      staticStyle: { display: "none" },
    },
    [
      _c("div", { staticClass: "pdf-render-box" }, [
        _c("div", { staticClass: "pdf-render-content" }, [
          _c("div", { staticClass: "pdf-render-item-middle-box" }, [
            _c("div", { staticClass: "pdf-render-item-box" }, [
              _c("div", { staticClass: "amount-box" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      `${_vm.refundBean.actualCurrency || "--"} ${
                        _vm.refundBean.actualAmount || "--"
                      }`
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "pdf-render-item" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("payment.refundInformation"))),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("t.amount")))]),
                  _c("div", [
                    _c("span", { staticClass: "weight500" }, [
                      _vm._v(
                        _vm._s(
                          `${_vm.refundBean.actualCurrency || "--"} ${
                            _vm.refundBean.actualAmount || "--"
                          }`
                        )
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("tables.detailsInfo.transactionID"))),
                  ]),
                  _c("span", { staticClass: "weight500" }, [
                    _vm._v(_vm._s(_vm.refundBean.transactionId)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("payment.paymentId")))]),
                  _c(
                    "span",
                    { staticClass: "weight500", staticStyle: { width: "50%" } },
                    [_vm._v(_vm._s(_vm.refundBean.paymentId))]
                  ),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("payment.dateAndTime")))]),
                  _c("span", { staticClass: "weight500" }, [
                    _vm._v(_vm._s(_vm.refundBean.dateAndTime)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "pdf-render-item" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("payment.receiverDetails"))),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("forms.wizard.name")))]),
                  _c(
                    "span",
                    { staticClass: "weight500", staticStyle: { width: "70%" } },
                    [_vm._v(_vm._s(_vm.refundBean.name))]
                  ),
                ]),
                _vm.refundBean.documentType && _vm.refundBean.documentNumber
                  ? _c("div", { staticClass: "item" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.refundBean.documentType.toLocaleUpperCase()
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "weight500" }, [
                        _vm._v(_vm._s(_vm.refundBean.documentNumber)),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "pdf-render-item" }, [
                _c("p", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("payment.payerDetails"))),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("payment.from")))]),
                  _c("span", { staticClass: "weight500" }, [
                    _vm._v(_vm._s(_vm.refundBean.from)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("payment.cnpj")))]),
                  _c("span", { staticClass: "weight500" }, [
                    _vm._v(_vm._s(_vm.refundBean.cnpj)),
                  ]),
                ]),
                _c("div", { staticClass: "item" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("payment.institution")))]),
                  _c("span", { staticClass: "weight500" }, [
                    _vm._v(_vm._s(_vm.refundBean.institution)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "pdf-render-footer" }, [
                _c("img", { attrs: { src: _vm.logoUrl, width: "130" } }),
                _vm.isTsWebsite
                  ? _c("a", { attrs: { href: "www.pagsmile.com" } }, [
                      _vm._v("pagsmile.com"),
                    ])
                  : _vm.isLtWebsite
                  ? _c("a", { attrs: { href: "www.luxtak.com" } }, [
                      _vm._v("luxtak.com"),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }